module.exports = __webpack_public_path__ + "img/tiff.8bd533f4.svg";